import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Card} from 'antd';
import './style.css';
import { setIcon } from '../../services/setIcon';


const HideInfoBoxComponent = ({text, action}) =>{
    return(
        <Card  className="hide-box"
        >
            <p>{text}</p>
            <a className="font-semibold" href={action}><Icon component={setIcon('person')} /> Become a member</a>
        </Card>
    )

}

HideInfoBoxComponent.propTypes = {
    text: PropTypes.string,
    action: PropTypes.string,

}

export default HideInfoBoxComponent;
